module.exports = __webpack_public_path__ + "static/media/image-content.0cfa0038.png";